import { bootstrapV2, getCustomer, getLoanApplicationState, getProfile, putProfile, updateAddress3 } from "@/generated/api/sdk.gen"
import type { PutProfileRequest, UpdateAddressRequest } from "@/generated/api/types.gen"
import type { Api } from "@/platform/api/api"
import { body } from "@/platform/api/gateways/common"

export const accountGateway = (api: Api) => ({
  profile: (signal?: AbortSignal) => body(getProfile(api.request({ signal }))),

  updateProfile: (request: PutProfileRequest) => body(putProfile({ ...api.request(), body: request })),

  loanApplicationState: (signal?: AbortSignal) => body(getLoanApplicationState(api.request({ signal }))),

  bootstrap: (signal?: AbortSignal) => body(bootstrapV2(api.request({ signal }))),

  customer: async (signal?: AbortSignal) => (await body(getCustomer(api.request({ signal })))).customer,

  updateAddress: async (addressId: string, request: UpdateAddressRequest) => (await body(updateAddress3({ ...api.request(), path: { addressId }, body: request }))).customer,
})

export type AccountGateway = ReturnType<typeof accountGateway>
